import { createReducer } from 'modules/util'

import ActionType from '../constants/actionTypes'

export const initialState = {
  selected: null
}

const handlers = {
  [ActionType.SELECT_PART]: selectPart
}

export default createReducer(initialState, handlers)

function selectPart(state, { payload: { index } }) {
  return { ...state, selected: index }
}



// WEBPACK FOOTER //
// ./client/modules/debate/reducers/strongest.js